export const PARTNER_LOGO_MINIMUM_HEIGHT = 144;
export const PARTNER_LOGO_MINIMUM_WIDTH = 144;